module.exports = __webpack_public_path__ + "img/kommune-615.87635c39.svg";